import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { useToast } from '@blend-ed/blendx-ui'
import { createContact } from '../api/HubspotCreateContact'
import { useSearchParams } from 'react-router-dom'
import { useMutation as useReactQueryMutation } from '@tanstack/react-query'

const ContactForm = ({ buttonText, buttonAction }) => {
  const toast = useToast()
  const [formData, setFormData] = useState({
    fullName: '',
    workEmail: '',
    phoneNumber: '',
    companyName: '',
    jobTitle: ''
  })

  const [emailError, setEmailError] = useState('')

  const [searchParams, setSearchParams] = useSearchParams()

  const { mutate: createContactMutation, isPending, isError, error } = useReactQueryMutation({
    mutationFn: (data) => createContact(data),
    onSuccess: () => {
      localStorage.setItem('formSubmitted', 'true');
      toast('check', 'success', 'Thank you for your interest! We will get back to you soon.')
      buttonAction()
      setFormData({
        fullName: '',
        workEmail: '',
        phoneNumber: '',
        companyName: '',
        jobTitle: ''
      })
    },
    onError: (err) => {
      console.log(err)
      if (err.message.includes('Contact already exists')) {
        localStorage.setItem('formSubmitted', 'true');
        toast('check', 'success', 'Thank you for your interest! We will get back to you soon.')
        buttonAction()
        setFormData({
          fullName: '',
          workEmail: '',
          phoneNumber: '',
          companyName: '',
          jobTitle: ''
        })
      } else if (err.message.includes('Error occurred while creating contact')) {
        toast('close', 'error', 'Please enter a valid email address')
        setEmailError('Please enter a valid email address')
      } else {
        toast('close', 'error', 'Something went wrong. Please try again.')
      }
    }
  })

  console.log(isPending, isError, error)

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })

    if (e.target.name === 'workEmail') {
      if (!validateEmail(e.target.value)) {
        setEmailError('Please enter a valid email address')
      } else {
        setEmailError('')
      }
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    createContactMutation({
      firstName: formData.fullName,
      email: formData.workEmail,
      phone: formData.phoneNumber,
      company: formData.companyName,
      jobTitle: formData.jobTitle,
      utm_source: searchParams.get('utm_source') || '',
      utm_campaign: searchParams.get('utm_campaign') || '',
      utm_medium: searchParams.get('utm_medium') || '',
      utm_content: searchParams.get('utm_content') || '',
      utm_term: searchParams.get('utm_term') || ''
    })
  }

  return (
    <Form className='referral-form__right-wrapper' onSubmit={handleSubmit}>
      <Form.Group className="mb-0">
        <Form.Control
          name='fullName'
          onChange={handleChange}
          type='text'
          placeholder='Full Name *'
          required
          className='referral-form__input'
        />
      </Form.Group>

      <Form.Group className="mb-0">
        <Form.Control
          name='workEmail'
          onChange={handleChange}
          type='email'
          placeholder='Work Email Address *'
          required
          className='referral-form__input'
          isInvalid={!!emailError}
        />
        <Form.Control.Feedback type="invalid">
          {emailError}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-0">
        <div className='referral-form__input-phone'>
          <PhoneInput
            defaultCountry='IN'
            placeholder="Enter phone number"
            value={formData.phoneNumber || ''}
            onChange={(value) => handleChange({ target: { name: 'phoneNumber', value } })}
          />
        </div>
      </Form.Group>

      <div className='d-flex flex-column flex-md-row referral-form__row'>
        <Form.Control
          name='companyName'
          onChange={handleChange}
          type='text'
          placeholder='Company Name'
          className='referral-form__input'
        />
        <Form.Control
          name='jobTitle'
          onChange={handleChange}
          type='text'
          placeholder='Job Title'
          className='referral-form__input'
        />
      </div>

      <Button
        variant='primary'
        type='submit'
        className="w-100 rounded-pill referral-form__button"
      >
        {buttonText}
      </Button>
    </Form>
  )
}

ContactForm.propTypes = {
  buttonText: PropTypes.string,
  buttonAction: PropTypes.func
}

ContactForm.defaultProps = {
  buttonText: 'Submit',
  buttonAction: () => { }
}

export default ContactForm 